module.exports = __webpack_public_path__ + "img/moon.9d6ca5d8.png";